// extracted by mini-css-extract-plugin
module.exports = {"banner":"Agenda_banner__3gV-v","btn":"Agenda_btn__Dni_h","itemsOnImg":"Agenda_itemsOnImg__2ebE3","button":"Agenda_button__3Ga32"};